module.exports = __webpack_public_path__ + "static/media/tone-picker-colour.713c6b758df2b36a08e6800d9a9ceca9d4f4ae4ee3f689590c85a58b8040c576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tone-picker-colour.png
// module id = 1012
// module chunks = 204